import React from 'react';
import EntryPoint from '../EntryPoint/EntryPoint';
import InstallAppScreen from '@/components/InstallApp/InstallAppScreen';
import '@/containers/App/Global.module.scss';
const IS_WEB_APP_DISABLED = process.env.WEB_APP_DISABLED === 'true';
const App = () => {
    if (IS_WEB_APP_DISABLED) {
        return React.createElement(InstallAppScreen, null);
    }
    return (React.createElement(EntryPoint, null));
};
export default App;
